import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { RawDraftContentState } from 'react-draft-wysiwyg';
import { useTranslate } from '@bynder/localization';
import { token } from '@bynder/design-system';
import RichText from './RichText';
import { MAX_LENGTH_TEXT_WIDGET } from '../../constants/widgets';
import { useNavigation } from '../../hooks/useNavigation';

interface Props {
  widgetId: string;
  sectionId: string;
  columnIndex: number;
  content?: RawDraftContentState;
  readOnly: boolean;
}

const TextWidget: React.FC<Props> = ({
  widgetId,
  sectionId,
  columnIndex,
  content,
  readOnly,
}) => {
  const { translate } = useTranslate();
  const { navigate } = useNavigation();
  const ref = useRef(null);

  useEffect(() => {
    const interceptClickEvent = e => {
      const element = e.target.parentElement.parentElement;
      if (element.tagName === 'A') {
        e.preventDefault();
        const href = element.getAttribute('href');
        const target = element.getAttribute('target');
        navigate(href, target === '_blank');
      }
    };
    const current = ref.current;
    current.addEventListener('click', interceptClickEvent);

    return () => {
      current.removeEventListener('click', interceptClickEvent);
    };
  }, [navigate]);

  return (
    <StyledTextWidget data-testid="textWidget" ref={ref}>
      <RichText
        widgetId={widgetId}
        sectionId={sectionId}
        content={content}
        columnIndex={columnIndex}
        maxLength={MAX_LENGTH_TEXT_WIDGET}
        placeholder={translate('TEXT_WIDGET.PLACEHOLDER')}
        readOnly={readOnly}
        autofocus={!content}
      />
    </StyledTextWidget>
  );
};

export default TextWidget;

export const StyledTextWidget = styled.div`
  color: ${token.gray800};
`;
